import React, { Component } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { CourseResource } from "../../../../../stores/CoursesStore/Types";
import { CourseCategoryResource } from "../../../../../stores/CourseCategoriesStore/Types";
import CourseBody from "./CourseBody";

interface Props {
  courseResource: CourseResource;
  useATag?: boolean;
  userIsInUk: boolean;
  cardClass?: string;
  isSample?: boolean;
  hideInMobile?: boolean;
}

const NewCourse: React.FC<Props> = ({
  courseResource,
  useATag,
  userIsInUk,
  cardClass,
  isSample,
  hideInMobile,
}) => {
  const courseLink = () => {
    if (courseResource.embedded_host_url) {
      return courseResource.embedded_host_url;
    } else if (courseResource.enrolment_id) {
      return `/enrolments/${courseResource.enrolment_id}`;
    }

    return courseResource.course_path;
  };

  if (useATag || courseResource.content_version == "upcoming") {
    return (
      <a className={`course-card ${cardClass}`} href={courseLink()}>
        <CourseBody
          courseResource={courseResource}
          userIsInUk={userIsInUk}
          isSample={isSample}
        />
      </a>
    );
  }

  return (
    <Link
      className={`course-card ${cardClass} ${hideInMobile ? "hidden" : ""}`}
      to={courseLink()}
    >
      <CourseBody
        courseResource={courseResource}
        userIsInUk={userIsInUk}
        isSample={isSample}
      />
    </Link>
  );
};

export default observer(NewCourse);
